import { render, staticRenderFns } from "./view-contact-modify.vue?vue&type=template&id=5ad0ff13&"
import script from "./view-contact-modify.vue?vue&type=script&lang=js&"
export * from "./view-contact-modify.vue?vue&type=script&lang=js&"
import style0 from "./view-contact-modify.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports